// ============================================================
// systems/pause.js — Pause / resume / countdown
// ============================================================
import { state } from '../state.js';
import { dom } from '../dom.js';
import { resumeMusic } from '../audio/manager.js';

/**
 * Pause the game — show overlay, disable plushie clicks.
 */
export function pauseGame() {
  state.paused = true;
  dom.pauseOverlay.classList.add('show');
  dom.pauseBtn.innerHTML = '&#x25B6;';
  dom.smiley.style.pointerEvents = 'none';
}

/**
 * Resume the game — hide overlay, re-enable plushie clicks.
 */
export function resumeGame() {
  state.paused = false;
  dom.pauseBtn.innerHTML = '&#x23F8;';
  dom.smiley.style.pointerEvents = '';
}

/**
 * 3-2-1 countdown before actually resuming.
 */
export function startResumeCountdown() {
  state.countdownActive = true;
  dom.pauseOverlay.classList.remove('show');
  dom.countdownOverlay.classList.add('show');
  let count = 3;
  dom.countdownNumber.textContent = count;
  dom.countdownNumber.style.animation = 'none';
  void dom.countdownNumber.offsetWidth;
  dom.countdownNumber.style.animation = 'countdownPop 0.6s ease-out';

  const cdInterval = setInterval(() => {
    count--;
    if (count > 0) {
      dom.countdownNumber.textContent = count;
      dom.countdownNumber.style.animation = 'none';
      void dom.countdownNumber.offsetWidth;
      dom.countdownNumber.style.animation = 'countdownPop 0.6s ease-out';
    } else {
      clearInterval(cdInterval);
      dom.countdownOverlay.classList.remove('show');
      state.countdownActive = false;
      resumeGame();
      resumeMusic(600);
    }
  }, 1000);
}
